import { FC } from "react";
import { Theme } from "@twilio-paste/theme";
import "../../cssOverride.css"
import { ReactElementProps } from "../../types";

export const ThemeProvider: FC<ReactElementProps> = ({ children }: ReactElementProps) => {
	return <Theme.Provider theme="default">{children}</Theme.Provider>;
};